import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';

export interface SearchlistCSSStyle extends UIComponentCSSStyle
{

}

export class  SearchlistCSSStyleImpl extends UIComponentCSSStyleImpl implements SearchlistCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            display:'flex',
            flexDirection:'row',
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/search/playlist/searchlistcss.tsx